import AppContext from "../../context/AppContext";

export default function buildLanguageChangeActions(appContext:AppContext) {
    return [
        {
            label: "EN",
            onclick: () => {
                appContext.setLangauge("en");
            }
        },
        {
            label: appContext.getMessageProvider().get("lang.my"),
            onclick: () => {
                appContext.setLangauge("my");
            }
        }
    ];
}